// F10 · icons.
//
// Lucide only, at 14 / 16 / 20 / 24, one stroke weight, never a Unicode glyph.
// The size and the stroke are CSS classes rather than Lucide's `size` and
// `strokeWidth` props, because a prop puts `16` and `1.75` back into component
// source as bare numbers — which design-lint cannot see and the token layer
// exists to prevent. A size that is not one of the four has no class to write.

import type { LucideIcon } from "lucide-react";
import { cx } from "./kit-state";

export type IconSize = "sm" | "md" | "lg" | "xl";

export interface IconProps {
  icon: LucideIcon;
  /** sm 14 · md 16 (default) · lg 20 · xl 24. */
  size?: IconSize;
  className?: string;
  /**
   * An icon is decorative unless it is the only thing carrying the meaning.
   * Passing a label makes it an image with a name; omitting it hides the icon
   * from assistive tech, which is correct beside a visible label.
   */
  label?: string;
}

export function Icon({ icon: Glyph, size = "md", className, label }: IconProps) {
  return (
    <Glyph
      className={cx("k-i", `k-i--${size}`, className)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
      focusable="false"
    />
  );
}
